module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-01-jp.4e13d80dc0c00c20e2895c38e6e52e8b.png";